import { render, staticRenderFns } from "./domaine-georges-roumier.vue?vue&type=template&id=f8e79924&scoped=true"
import script from "./domaine-georges-roumier.vue?vue&type=script&lang=js"
export * from "./domaine-georges-roumier.vue?vue&type=script&lang=js"
import style0 from "./domaine-georges-roumier.vue?vue&type=style&index=0&id=f8e79924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e79924",
  null
  
)

export default component.exports